import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, MenuItem, CircularProgress,
} from '@mui/material'
import { getFileTypes } from 'ducks/files/selectors'
import { updatePortfolioFile } from 'services/portfolioDocumentsService'
import { toast } from 'react-toastify'

const ORANGE = '#D24724'

export default function EditDocumentModal({ portfolioId, file, onSaved, onClose }) {
  const fileTypesRaw = useSelector(getFileTypes)
  const [displayName, setDisplayName] = useState(file.displayName || file.name || '')
  const [description, setDescription] = useState(file.description || '')
  const [fileTypeId, setFileTypeId] = useState(file.fileType?.id || file.fileTypeId || '')
  const [busy, setBusy] = useState(false)

  const sortedTypes = useMemo(() => {
    const list = Array.isArray(fileTypesRaw) ? fileTypesRaw : []
    return [...list].sort((a, b) => (a.name || '').localeCompare(b.name || ''))
  }, [fileTypesRaw])

  const save = async () => {
    const name = displayName.trim()
    if (!name) { toast.error('Give the document a name'); return }
    setBusy(true)
    try {
      await updatePortfolioFile(portfolioId, file.id, {
        displayName: name,
        description: description.trim(),
        fileTypeId: fileTypeId || null,
      })
      toast.success('Document updated')
      onSaved && onSaved()
      onClose()
    } catch (e) {
      toast.error(e.response?.data?.message || 'Could not update the document')
    } finally { setBusy(false) }
  }

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit document</DialogTitle>
      <DialogContent dividers>
        <TextField fullWidth label="Name" value={displayName} onChange={(e) => setDisplayName(e.target.value)} margin="dense" />
        <TextField fullWidth multiline minRows={3} label="Description" value={description}
          onChange={(e) => setDescription(e.target.value)} margin="dense" />
        {sortedTypes.length > 0 && (
          <TextField select fullWidth label="Document type" value={fileTypeId}
            onChange={(e) => setFileTypeId(e.target.value)} margin="dense">
            <MenuItem value=""><em>Unclassified</em></MenuItem>
            {sortedTypes.map((t) => <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>)}
          </TextField>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={save} disabled={busy}
          sx={{ backgroundColor: ORANGE, '&:hover': { backgroundColor: '#bd3f20' } }}>
          {busy ? <CircularProgress size={18} sx={{ color: '#fff' }} /> : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
